import React from "react";
import ReactTags from "react-tag-autocomplete";
// import Autocomplete from "react-autocomplete";
import _ from "lodash";
import "./filterApplicant.css";

class FilterApplicant extends React.Component {
  state = {
    title: "",
    skills: [],
    skillSuggestions: [],
    status: "",
    statusSuggestions: [
      {
        label: "Not Yet Processed",
        id: 0
      },
      {
        label: "Invitation sent",
        id: 1
      },
      {
        label: "Invitation not attended",
        id: 2
      },
      {
        label: "Passed",
        id: 3
      },
      {
        label: "Failed",
        id: 4
      },
      {
        label: "Keep In View",
        id: 5
      }
    ],
    // company: "",
    // companySuggestions: [],
    vacancyId: "",
    locationId: ""
  };

  handleSkillDelete(i) {
    const skills = this.state.skills.slice(0);
    skills.splice(i, 1);
    this.setState({ skills });
  }

  handleSkillAddition(skill) {
    const skills = [].concat(this.state.skills, skill);
    this.setState({ skills });
  }

  getSkillSuggestions(applicants) {
    if (applicants !== undefined && applicants.length > 0) {
      const applicantSkill = [];
      _.forEach(applicants, (applicant, index) => {
        let all = applicant.skills.split(",");
        applicantSkill.push(all);
      });
      const flattenSkill = _.flatten(applicantSkill);
      let skills = _.uniq(flattenSkill);
      const allSkill = skills.map((value, index) => ({
        id: index,
        name: value
      }));
      return allSkill;
    }

    return [];
  }

  // getCompanySuggestions(applicants) {
  //   if (applicants !== undefined && applicants.length > 0) {
  //     const companyArr = [];
  //     _.forEach(applicants, (applicant, index) => {
  //       _.forEach(applicant.employments, (company, index) => {
  //         companyArr.push({ label: company.companyName });
  //       });
  //     });

  //     const uniqData = _.uniqBy(companyArr, 'label');

  //     return uniqData;
  //   }
  //   return [];
  // }

  componentWillReceiveProps(nextProps) {
    const skillSuggestions = this.getSkillSuggestions(nextProps.applicants);
    // const companySuggestions = this.getCompanySuggestions(nextProps.applicants);

    this.setState({
      skillSuggestions: skillSuggestions
      // companySuggestions: companySuggestions
    });
  }

  handleFilter(e) {
    e.preventDefault();
    let status = _.find(
      this.state.statusSuggestions,
      s => s.label === this.state.status
    );
    let vacancyId = "00000000-0000-0000-0000-000000000000";
    let locationId = "00000000-0000-0000-0000-000000000000";
    if (status === undefined) status = { id: 0 };
    if (this.state.vacancyId !== "") vacancyId = this.state.vacancyId;
    if (this.state.locationId !== "") locationId = this.state.locationId;
    this.props.onSubmit(
      vacancyId,
      this.state.title,
      this.state.skills,
      status.id,
      locationId
    );
  }

  handleReset(e) {
    e.preventDefault();
    this.setState({
      title: "",
      skills: [],
      status: "",
      // company: "",
      vacancyId: "",
      locationId: ""
    });
    this.props.onReset();
  }

  render() {
    return (
      <div className="filter-applicant-container clearfix">
        <form onSubmit={this.handleFilter.bind(this)}>
          <div className="filter-applicant--vacancy form-group">
            <label className="font-weight-bold">Vacancy</label>
            <select
              name="vacancyId"
              className="form-control"
              value={this.state.vacancyId}
              onChange={e => this.setState({ vacancyId: e.target.value })}
              autoFocus={true}
            >
              <option value="">Select vacancy</option>
              {this.props.vacancies &&
                this.props.vacancies.map(v => {
                  return (
                    <option key={v.id} value={v.id}>
                      {v.jobTitle}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="filter-applicant--title form-group">
            <label className="font-weight-bold">Applicant Name</label>
            <input
              type="text"
              name="title"
              className="form-control"
              value={this.state.title}
              onChange={e => {
                this.setState({ title: e.target.value });
              }}
            />
          </div>
          {/* <div className="filter-applicant--company form-group">
            <label className="font-weight-bold">Company</label>
            <Autocomplete
              getItemValue={item => item.label}
              items={this.state.companySuggestions}
              renderItem={(item, isHighlighted) => (
                <div
                  style={{ background: isHighlighted ? "#007bff" : "white", color: isHighlighted ? "white" : "#333" }}
                  key={item.label}
                >
                  {item.label}
                </div>
              )}
              value={this.state.company}
              onChange={e => this.setState({ company: e.target.value })}
              onSelect={val => this.setState({ company: val })}
            />
          </div> */}
          <div className="filter-applicant--skill form-group">
            <label className="font-weight-bold">Skill</label>
            <ReactTags
              autoFocus={false}
              tags={this.state.skills}
              suggestions={this.state.skillSuggestions}
              handleDelete={this.handleSkillDelete.bind(this)}
              handleAddition={this.handleSkillAddition.bind(this)}
            />
          </div>
          <div className="filter-applicant--status form-group">
            <label className="font-weight-bold">Status</label>
            <select
              className="form-control"
              value={this.state.status}
              onChange={e => this.setState({ status: e.target.value })}
            >
              <option value="">Select Status</option>
              {this.state.statusSuggestions &&
                this.state.statusSuggestions.map(v => {
                  return (
                    <option key={v.label} value={v.label}>
                      {v.label}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="filter-applicant--location form-group">
            <label className="font-weight-bold">Job Location</label>
            <select
              name="location"
              className="form-control"
              value={this.state.locationId}
              onChange={e => this.setState({ locationId: e.target.value })}
            >
              <option value="">Select location</option>
              {this.props.locations &&
                this.props.locations.map(v => {
                  return (
                    <option key={v.id} value={v.id}>
                      {v.location}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="filter-applicant--actions form-group">
            <button type="submit" className="btn btn-primary">
              Filter
            </button>&nbsp;
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.handleReset.bind(this)}
            >
              Reset
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default FilterApplicant;



// WEBPACK FOOTER //
// ./src/components/FilterApplicant/filterApplicant.js